import { derived, writable } from 'svelte/store';

export const newsletterFormVisible = writable(false);

export const footerVisible = writable(false);

export const footerOrNewsletterFormVisible = derived(
	[newsletterFormVisible, footerVisible],
	([newsletter, footer]) => newsletter || footer
);
